import React, { Component } from "react";
import ReactDOM from "react-dom";
import Loqateservice from "./services/LoqateService";
import SpinnerButton from "./common/SpinnerButton";
import InputValidationError from "./common/InputValidationError";
import ManualAddress from "./quotes/ManualAddress";
import FilesUpload from "./quotes/FilesUpload";
import SelectExtras from "./quotes/SelectExtras";
import CustomerDetails from "./quotes/CustomerDetails";
import QuotesService from "./services/QuotesService";
import QuotesManualAddress from "./quotes/QuotesManualAddress";

class QuotesForm extends Component {
    constructor(props) {
        super(props);

        this.LoqateService = new Loqateservice();
        this.quotesService = new QuotesService();

        this.handleSelectPostcode = this.handleSelectPostcode.bind(this);
        this.onChange = this.onChange.bind(this);
        this.toggleManualAddress = this.toggleManualAddress.bind(this);
        this.manualAddressChange = this.manualAddressChange.bind(this);
        this.updateParentState = this.updateParentState.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            postcode: "",
            additional_info: "",
            availableAddresses: [],
            extras: [],
            serverError: [],
            address: "",
            manualAddress: false,
            manualAddressInfo: {
                property_number: "",
                street_name: "",
                city_name: "",
                postcode: "",
            },
            postcodeValid: false,
            postcodeError: "",
            files: [],
            first_name: "",
            last_name: "",
            email: "",
            phone: "",
            errors: {},
            loading: false,
            isLoading: false,
            disabled: false,
        };
    }

    onChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let err = { ...this.state.errors };

        delete err[name];

        this.setState({
            [name]: value,
            errors: err,
        });
    }

    updateParentState(state, data) {
        this.setState({
            [state]: data,
        });
    }

    manualAddressChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        let stateObj = { ...this.state.manualAddressInfo };
        stateObj[name] = value;
        console.log(stateObj);

        this.setState({
            manualAddressInfo: stateObj,
        });
    }

    toggleManualAddress(e) {
        e.preventDefault();
        this.setState({
            manualAddress: !this.state.manualAddress,
            address: "",
            manualAddressInfo: {
                property_number: "",
                street_name: "",
                city_name: "",
                postcode: "",
            },
        });
    }

    checkIfUkPostcode() {
        let validatePostcode = new RegExp(
            "([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\\s?[0-9][A-Za-z]{2})"
        );
        let postcode =
            this.state.manualAddressInfo.postcode || this.state.postcode;
        return validatePostcode.test(postcode);
    }

    validation() {
        const { manualAddress, manualAddressInfo } = this.state;
        let errors = {};
        let fields = [
            "postcode",
            "address",
            "first_name",
            "last_name",
            "email",
            "phone",
            "files",
        ];

        let videoMimeTypes = [
            "video/3gpp2",
            "video/avi",
            "video/f4f",
            "video/f4m",
            "video/flv",
            "video/mp2t",
            "video/mp4",
            "video/mpeg",
            "video/mpegurl",
            "video/mpg4",
            "video/msvideo",
            "video/quicktime",
            "video/vnd.mpeg.dash.mpd",
            "video/webm",
            "video/x-flash-video",
            "video/x-flv",
            "video/x-mp4",
            "video/x-mpegurl",
            "video/x-mpg4",
            "video/x-ms-asf",
            "video/x-ms-wmv",
            "video/x-msvideo",
        ];

        let imageMimeTypes = [
            "image/avif",
            "image/gif",
            "image/icon",
            "image/jpg",
            "image/jpeg",
            "image/png",
            "image/tiff",
            "image/vnd.microsoft.icon",
            "image/webp",
            "image/x-icon",
        ];

        fields.map((field) => {
            if (field === "files") {
                let files = this.state.files.filter((file) => file);
                let passes = false;
                let imageCount = 0;

                files.map((file) => {
                    if (videoMimeTypes.includes(file.type.toLowerCase())) {
                        passes = true;
                    } else if (
                        imageMimeTypes.includes(file.type.toLowerCase())
                    ) {
                        imageCount++;
                    }

                    if (imageCount >= 3) {
                        passes = true;
                    }
                });

                if (!passes) {
                    errors[field] =
                        "Please upload at least three images or one video";
                }
            } else if (field === "address") {
                if (manualAddress) {
                    if (
                        !manualAddressInfo.city_name ||
                        !manualAddressInfo.property_number ||
                        !manualAddressInfo.street_name ||
                        !manualAddressInfo.postcode
                    ) {
                        errors[field] = "All fields are required.";
                    }
                    if (!this.checkIfUkPostcode(manualAddressInfo.postcode)) {
                        errors[field] = "Postcode is not valid";
                        console.log("Postcode wrong!");
                    }
                } else {
                    if (!this.state[field]) {
                        errors[field] = "This field is required.";
                    }
                }
            } else {
                if (!this.state[field]) {
                    errors[field] = "This field is required.";
                }
            }
        });

        //  Set errors in state
        this.setState({ errors: errors });
        return Object.keys(errors).length === 0;
    }

    handleSelectPostcode(event) {
        event.preventDefault();
        const { postcode } = this.state;
        let err = { ...this.state.errors };
        //  Check validation
        if (this.state.postcode || this.state.manualAddress.postcode) {
            //  Loader flag
            this.setState({ loading: true });

            if (this.checkIfUkPostcode(postcode)) {
                this.setState({ postcodeValid: true, postcodeError: "" });

                this.LoqateService.getLocationId(postcode).then((location) => {
                    let container = location.data.Items[0]["Id"];
                    let type = location.data.Items[0]["Type"];
                    this.LoqateService.getAvailableAddressesNew(
                        postcode,
                        container,
                        type
                    )
                        .then((address) => {
                            this.setState({
                                availableAddresses: address.data.Items,
                                loading: false,
                            });
                        })
                        .catch((err) => {
                            this.setState({ loading: false });
                        });
                });
            } else {
                err.postcode = "The postcode is not valid";
                this.setState({
                    postcodeValid: false,
                    errors: err,
                    loading: false,
                });
            }
        } else {
            err.postcode = "This field is required";
            this.setState({ errors: err });
        }
    }

    onSubmit(event) {
        event.preventDefault();
        const {
            first_name,
            last_name,
            email,
            phone,
            extras,
            files,
            address,
            additional_info,
        } = this.state;

        if (this.validation()) {
            this.setState({
                isLoading: true,
                serverError: "",
                success: "",
                disabled: true,
            });
            const formData = new FormData();
            const addressFormat = this.state.availableAddresses.filter(
                (add) => add.Id === address
            );

            if (extras.length > 0) {
                // ?????
                for (let i = 0; i < extras.length; i++) {
                    let item = extras[i];
                    formData.append(`extras[${i}][id]`, item.id);
                    formData.append(`extras[${i}][quantity]`, item.qty);
                }
            }
            if (additional_info) {
                formData.append("additional_info", additional_info);
            }

            if (this.state.manualAddress) {
                formData.append(
                    "address",
                    this.state.manualAddressInfo.property_number +
                        ", " +
                        this.state.manualAddressInfo.street_name +
                        ", " +
                        this.state.manualAddressInfo.postcode
                );
            } else {
                formData.append(
                    "address",
                    `${addressFormat[0].Text}, ${addressFormat[0].Description}`
                );
            }
            formData.append("first_name", first_name);
            formData.append("last_name", last_name);
            formData.append("email", email);
            formData.append("phone", phone);
            let quoteFiles = files.filter((file) => file);
            quoteFiles.map((file) => {
                formData.append("files[]", file);
            });

            this.quotesService
                .submitQuote(formData)
                .then((res) => {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "generate_lead",
                        form_name: "quote_form",
                    });

                    setTimeout(() => {
                        this.setState({
                            isLoading: false,
                            disabled: false,
                            success:
                                "Thank you for your quotation request, which is being processed. We normally " +
                                "return quotations within an hour – seven days a week, 9.00 am to 9.00 pm. " +
                                "Regards, Wascle",
                        });
                    }, 1000);
                })
                .catch((err) => {
                    console.log({ ...err });
                    this.setState({
                        serverError: err.response.data.errors,
                        isLoading: false,
                        disabled: false,
                    });
                });
        }
    }

    render() {
        const {
            postcode,
            address,
            availableAddresses,
            postcodeValid,
            manualAddress,
            manualAddressInfo,
            errors,
            loading,
            first_name,
            last_name,
            email,
            phone,
            isLoading,
        } = this.state;
        return (
            <div className="client-quotes-form">
                <section className="quotes-form">
                    <div className="container">
                        <div className="row">
                            <div className="offset-md-2 col-md-8 text-center">
                                <h3>
                                    To get the process started, please fill in
                                    the required details below
                                </h3>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="first_name"
                                        className="form-control quotes-form-input"
                                        onChange={(e) => this.onChange(e)}
                                        value={first_name}
                                        placeholder="First Name"
                                    />
                                    <InputValidationError
                                        error={errors.first_name}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="last_name"
                                        className="form-control quotes-form-input"
                                        onChange={(e) => this.onChange(e)}
                                        value={last_name}
                                        placeholder="Last Name"
                                    />
                                    <InputValidationError
                                        error={errors.last_name}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="email"
                                        className="form-control quotes-form-input"
                                        onChange={(e) => this.onChange(e)}
                                        value={email}
                                        placeholder="Email"
                                    />
                                    <InputValidationError
                                        error={errors.email}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="phone"
                                        className="form-control quotes-form-input"
                                        value={phone}
                                        onChange={(e) => this.onChange(e)}
                                        placeholder="Phone"
                                    />
                                    <InputValidationError
                                        error={errors.phone}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <textarea
                                        style={{ resize: "none" }}
                                        rows="4"
                                        name="additional_info"
                                        className="form-control quotes-form-input"
                                        value={this.state.additional_info}
                                        onChange={(e) =>
                                            this.setState({
                                                additional_info: e.target.value,
                                            })
                                        }
                                        placeholder="Please make a note of any parking/access issues or anything else we will need to know to make the collection."
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="quotes-files pt-4">
                    <div className="container">
                        <FilesUpload
                            updateParentState={this.updateParentState}
                            errors={errors}
                        />
                    </div>
                </section>

                <section className="quotes-postcode-section pt-4">
                    <div className="container">
                        <div className="row justify-content-center py-3">
                            <h4 className="quotes-heading">
                                Enter your postcode
                            </h4>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-10 justify-content-center">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="postcode"
                                        className="form-control quotes-form-input"
                                        value={postcode}
                                        onChange={this.onChange}
                                        placeholder="Postcode"
                                    />
                                </div>
                            </div>
                        </div>
                        <InputValidationError error={errors.postcode} />
                        <div className="text-center pt-2 pb-2">
                            <SpinnerButton
                                onClick={this.handleSelectPostcode}
                                loading={loading}
                                name="SELECT"
                            />
                        </div>
                    </div>
                </section>

                <section className="quotes-address-section pt-4">
                    <div className="container">
                        {postcodeValid && !loading && !manualAddress && (
                            <div className="row justify-content-center ">
                                <div className="col-md-10 justify-content-center">
                                    <div className="form-group">
                                        <select
                                            name="address"
                                            value={address}
                                            className="form-control quotes-form-select"
                                            onChange={this.onChange}
                                        >
                                            <option
                                                value=""
                                                name="address_find"
                                                disabled
                                            >
                                                Select address...
                                            </option>
                                            {availableAddresses.map(
                                                (address) => {
                                                    return (
                                                        <option
                                                            value={address.Id}
                                                            key={address.Id}
                                                        >
                                                            {address.Text +
                                                                ", " +
                                                                address.Description}
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </select>
                                        <div className="pull-right">
                                            <small className="text-danger">
                                                <a
                                                    href="#"
                                                    onClick={(e) =>
                                                        this.toggleManualAddress(
                                                            e
                                                        )
                                                    }
                                                    style={{ color: "#3F3F3F" }}
                                                >
                                                    Enter address manually
                                                </a>
                                            </small>
                                        </div>
                                    </div>
                                    <InputValidationError
                                        error={errors.address}
                                    />
                                </div>
                            </div>
                        )}

                        {postcodeValid && manualAddress && (
                            <QuotesManualAddress
                                onChange={this.manualAddressChange}
                                toggleManualAddress={(e) =>
                                    this.toggleManualAddress(e)
                                }
                                info={manualAddressInfo}
                                errors={errors}
                            />
                        )}
                    </div>
                </section>

                {postcodeValid && !loading && (
                    <div className="container">
                        <div className="text-center btn-submit quotes-form-submit">
                            <SpinnerButton
                                onClick={this.onSubmit}
                                loading={isLoading}
                                disabled={this.state.disabled}
                                name="SUBMIT QUOTE REQUEST"
                            />

                            {this.state.success && (
                                <div className="row justify-content-center pt-5">
                                    <div className="col-md-10 justify-content-center">
                                        <div
                                            className="alert alert-success"
                                            role="alert"
                                        >
                                            <p className="m-0">
                                                {this.state.success}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {this.state.serverError &&
                                this.state.serverError["files.0"] && (
                                    <p>{this.state.serverError["files.0"]}</p>
                                )}
                            {typeof this.state.errors.files !== "undefined" && (
                                <InputValidationError error={errors.files} />
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

if (document.getElementById("quotesForm")) {
    const element = document.getElementById("quotesForm");
    ReactDOM.render(
        <QuotesForm
            stripe_key={element.dataset.stripe_key}
            extras={JSON.parse(element.dataset.extras)}
            cut_off={element.dataset.cut_off}
            paymentError={element.dataset.payment_error}
        />,
        element
    );
}

export default QuotesForm;
